// https://support.pendo.io/hc/en-us/community/posts/4408558114331-stopGuides-doesn-t-work-as-expected
const hidePendoGuides = () => {
	try {
		console.log('Stopping all Pendo Guides from NAPIC Onboarding Modal')
		window?.pendo?.stopGuides?.()
	} catch (e) {
		console.error(`Failed to stop all pendo guides: ${e}`)
	}
}

const startPendoGuides = () => {
	try {
		console.log('Starting all Pendo Guides from NAPIC Onboarding Modal')
		window?.pendo?.startGuides?.()
	} catch (e) {
		console.error(`Failed to start all pendo guides: ${e}`)
	}
}

export { hidePendoGuides, startPendoGuides }
